import React from "react";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “¡Rayos y centellas!”, gritó el capitán. “¡Rayos y centellas!”, repitió el segundo a bordo. “¡Rayos y centellas!”,
      repitieron el timonel, el contramaestre y todos los marineros, hasta el grumete de las cocinas.
    </p>
    <p className="content justified">
      Esto sucedía en un buque de tres palos que navegaba en el mar de las Antillas. El buque se llamaba, no hay para
      qué preguntarlo, el “Rayos y Centellas” y lo mandaba el capitán Trueno, llevando como su segundo a bordo al
      valiente teniente de navío Relámpago.
    </p>
    <p className="content justified">
      Este breve cuento de piratas empieza con mucho barullo en la mitad del mar. Los piratas, como es de esperarse, van
      en busca del tesoro del malvado Malasentrañas y, tras estudiar varias veces el mapa, llegan a la Isla de
      Tormentas. Entonces hay un detalle muy importante que determina todo: la única forma para saber dónde están las
      riquezas es tomar una canilla de muerto para medir la distancia de treinta y dos longitudes desde el sepulcro del
      tuerto O’Neil hasta el lugar indicado en el mapa.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Hasta este punto parece una historia de piratas común y corriente; sin embargo, Oswaldo Díaz Díaz la empapa de
      humor negro cuando el terrible capitán Trueno empieza a mochar canillas a diestra y siniestra para ver si de esa
      forma encuentra la canilla con la medida exacta que dé con el lugar del tesoro.
    </p>
    <p className="content justified">
      Al final, después de que toda la tripulación está sin media pierna, Trueno cae en cuenta de que las instrucciones
      decían: “la canilla de un muerto”, entonces, con suma torpeza Trueno se quita la vida para poder usar su propia
      canilla, pero todos sabemos que ningún pirata ha podido revivir para encontrar un tesoro con su propia canilla… ¿o
      sí?
    </p>
    <p className="content justified">
      Este es uno de los primeros cuentos infantiles publicados por Oswaldo Díaz Díaz y hace parte de la antología{" "}
      <i>El país de Lilac</i> de 1938. Es cuento muy particular por varias razones: por un lado, por el uso del humor
      negro y la fantasía con los que da un giro inesperado a la típica historia de piratas. Por otro lado, porque es
      una historia que se sale del molde de los cuentos para niños que se escribían en las décadas de 1930 y 1940 en
      Colombia, cuando se pensaba que la única función de los cuentos infantiles era dejar una enseñanza.
    </p>
    <p className="content justified">
      “Rayos y centellas” está escrito para sorprender a los pequeños, hacerlos reír y quizás consternar un poco a los
      adultos conservadores que se podrían escandalizar con las canillas mochadas (tranquilos, las canillas volverán a
      las piernas de la tripulación con unas palabras mágicas de Tormenta, el segundo al mando).
    </p>
    <p className="content justified">
      Es probable que por ser un cuento tan adelantado a su época no haya tenido más reediciones, pues la única vez que
      vio la luz fue en esta hermosa edición ilustrada por el célebre artista Sergio Trujillo Magnenat.
    </p>
    <p className="content justified">
      Por fortuna, el libro se encuentra en la Biblioteca Nacional de Colombia y esperamos que un editor —de esos a los
      que le gustan los tesoros y no sacrifican canillas— lo encuentre y lo reedite.
    </p>
  </div>
);

export const sections = <div className="sectionsReview"></div>;
